module.exports = __webpack_public_path__ + "img/g-end.b6b0eb6.jpg";